import { useQueryClient } from 'react-query';
import { QUERY_KEYS, Theme } from '@24i/nxg-sdk-photon';
import { useState } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';

import { FetchParams, FetchResult } from '../types';
import { useThemeData } from '../../../context/ThemeData';
import { handleError } from '../../../utils/error';

export const useThemeFetch = (): FetchResult<Theme | null> => {
    const queryClient = useQueryClient();
    const { fetchTheme } = useThemeData();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);

    const fetch = async (params?: FetchParams): Promise<Theme | null> => {
        try {
            setIsLoading(true);
            setError(undefined);

            if (params?.forceRefresh) {
                await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.appTheme] });
            }

            return await queryClient.fetchQuery({
                queryKey: QUERY_KEYS.appTheme,
                queryFn: fetchTheme,
            });
        } catch (e) {
            const err = handleError(e, 'Failed to fetch theme');
            setError(err);
            log('Error fetching application theme', err);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { fetch, isLoading, error };
};
